import {
    useWindowDimensions
} from "react-native";
import {
    NCoreUIKitTheme
} from "../../core/hooks";
import type {
    BreakpointConstantType,
    BreakpointType
} from "../../types/theme";

export const getBreakpoint = ({
    shapeConfigs,
    width
}: BreakpointConstantType): BreakpointType => {
    if(width < shapeConfigs.compactBreakpoint) {
        return "compact";
    }

    if(width < shapeConfigs.wideBreakpoint) {
        return "medium";
    }

    return "wide";
};

const useBreakpoint = () => {
    const {
        shapeConfigs
    } = NCoreUIKitTheme.useContext();

    const {
        width
    } = useWindowDimensions();

    return getBreakpoint({
        shapeConfigs,
        width
    });
};
export default useBreakpoint;
